import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Text,
	Link,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextHousehold: React.FC = () => (
	<>
		<Flex
			as="section"
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height={{ xs: "400px", sm: "350px" }}
			minH={{ xs: "400px", sm: "350px" }}
			maxH="450px"
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/jpg/blogBanner.jpg"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDirection="column"
			>
				<Flex
					alignItems={{ xs: "flex-start", md: "flex-start" }}
					justifyContent="center"
					columnGap="24px"
					justifyItems="center"
					width="100%"
					display="flex"
					as="section"
					rowGap="30px"
					flexDir={{
						xs: "column",
						md: "row",
					}}
				>
					<Flex flexDir="column" rowGap="16px">
						<Heading
							color="white"
							fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
							fontWeight="800"
							lineHeight={{ xs: "35px", lg: "83px" }}
						>
							#TheContext
						</Heading>
					</Flex>
					<Box
						w="1.5px"
						h={{ xs: "100%" }}
						bgColor="white"
						display={{ xs: "none", md: "block" }}
					/>
					<Box
						w={{ xs: "70%", sm: "60%" }}
						h="1.5px"
						bgColor="white"
						display={{ xs: "block", md: "none" }}
					/>
					{/*  */}
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						The EPIC Opportunity
					</Heading>
				</Flex>

				<Text
					fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
					fontWeight="600"
					color="white"
					lineHeight="28px"
					textAlign={{
						xs: "left",
						md: "center",
					}}
					mt="20px"
				>
					Unearthing the True Potential of Entrepreneurial Households in India
				</Text>
			</Container>
		</Flex>
		<Container
			as="section"
			maxW="container.xl"
			pb="80px"
			pt="40px"
			minH="420px"
			display={{ xs: "flex", md: "inherit" }}
			flexDirection="column"
		>
			<Box
				float={{ xs: "right", md: "left" }}
				alignSelf={{ xs: "center", md: "flex-start" }}
				mx={{ xs: "0px", md: "0px" }}
				mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
				mb="20px"
			>
				<Flex
					flexDir={{
						xs: "column",
						md: "row",
					}}
					gap="20px"
					alignItems={{
						xs: "center",
						md: "unset",
					}}
				>
					<Img
						src="https://static.levocdn.com/WGLBUT82/Jyotsna%20(1)-7165743064822427178.jpeg"
						alt="jyotsna Krishnann"
						width="250px"
						height="250px"
						objectFit="cover"
						borderRadius="50%"
					/>
					<Flex direction="column">
						<Heading
							as="h1"
							fontWeight="800"
							pt="20px"
							variant="reportCardTitle"
							fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Jyotsna Krishnan
							<Link
								href="https://www.linkedin.com/in/jyotsna-krishnan-3b44997/"
								target="_blank"
								display={{ xs: "inline-block", md: "none" }}
								pl={"10px"}
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Heading>
						<Text
							color="text.mediumBlack"
							maxW={{
								xs: "100%",
								md: "120px",
							}}
							w="100%"
							fontSize="16px"
							lineHeight="22px"
							fontStyle="italic"
							textAlign={{
								xs: "center",
								md: "left",
							}}
						>
							Managing Partner, Elevar Equity and Co- founder Enmasse
						</Text>

						<Link
							href="https://www.linkedin.com/in/jyotsna-krishnan-3b44997/"
							target="_blank"
							display={{
								xs: "none",
								md: "block",
							}}
						>
							<IconButton
								aria-label="linkedin"
								icon={<FaLinkedin size="28px" color="#067acc" />}
								variant="unstyled"
								cursor="pointer"
							/>
						</Link>
					</Flex>
				</Flex>
			</Box>
			<Box>
				<Box mt="16px" mb="20px">
					<Text variant="blogAnswer">
						Households have long been the silent yet formidable drivers of
						growth in the Indian economy. They are the unheralded backbone of
						economic activity and the India story itself.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" pt="8px">
						Leveraging 20 years of experience from Elevar Equity, Enmasse World
						is on a mission to shift this narrative by presenting a paradigm for
						understanding and valuing Indian households. At the core of this
						reimagined perspective are 247 million Entrepreneurial Households
						(EH)TM – a segment that thrives quietly yet robustly across the
						country. Distinguished by multiple income streams, these households
						transform their diverse formal and informal incomes and borrowings
						into a network of transactions, encompassing both inflows and
						outflows
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" mt="16px" mb="8px">
						Recognising the size of this opportunity and the magnitude of their
						economic vibrancy is essential. We stand on the brink of a
						transformative moment over the next couple of decades, one that
						demands our immediate attention and urgent action
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						The first step here is to recognise these EHs as entrepreneurial
						powerhouses, channelling their multiple sources of income to turn
						their aspirations into reality. These EHs are not households that
						struggle to meet basic subsistence needs - they own at least a pucca
						(permanent) house. Nor are they affluent enough, in the traditional
						sense, to qualify for on-demand credit cards. However, they are
						discerning customers who focus on core needs and the creation of
						income-generating assets that foster virtuous economic cycles
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						The second step involves challenging the conventional metrics of
						household economic potential, which have traditionally focused on
						income or consumption patterns. Instead, one must consider a more
						dynamic and holistic approach by focusing on the 'Core Transaction
						Value' (CTV)TM. This metric encapsulates the core facets of an EH’s
						economic life, derived from the network of their transactions,
						including income inflows, curated borrowings, priority spending, and
						business investments. By adopting this perspective, we view the
						economic life of a household in its entirety, thereby offering a
						richer and more accurate depiction of its current economic potential
						and aspirations.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						Taken together, this analysis reveals a remarkable opportunity for
						these EHs - one potentially worth trillions of dollars. Preliminary
						estimates, based on independent research conducted by Praxis Global
						Alliance, peg the Economic Power of these Industrious Communities -
						or simply, the EPIC Opportunity at USD 8.8 Trillion for FY 2023
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						This isn't merely a statistic; it's a call to action, spotlighting
						the untapped, vast potential of these households. The EPIC
						Opportunity is a testament to what can be achieved by harnessing
						this potential. Crystallising the EH economic archetype and
						formulating the CTV metric was more than an exercise in merely
						analysing public data or aggregating existing economic models. A
						world-class team of partners, including Praxis and 1Lattice,
						developed innovative analytical tools together with Enmasse. For
						instance, an asset ownership model was developed to enumerate EHs.
						Second, the CTV was broken down into its component parts, and each
						part was modelled carefully.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						This year-long process was illuminating in more than one way. First,
						it revealed the power of combining existing data sets with the two
						decades of Elevar’s experience working with households across India
						and the world. Second, it revealed the economic vibrancy of these
						households. By moving beyond conventional measures of income or
						consumption, we begin to gain a three-dimensional, working
						understanding of household economic activity.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						The journey into the EPIC Opportunity is underway, and the momentum
						is building. We're not just analysing—we're scaling our
						understanding of EH and CTV to unlock unprecedented insights and
						opportunities. Ultimately, our goal is to build the infrastructure
						for intervention at scale. How can we build businesses that will
						support these EHs over the coming decades? How can companies design
						goods and services that fulfil both EH aspirations and business
						goals? At Enmasse, finding answers to these questions is our raison
						d’etre.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						As we forge ahead, our unwavering focus is on empowering these
						millions of Entrepreneurial Households. It is a reality on the
						ground that promises to transform the Indian economic landscape and
						usher in a new generation of prosperity and opportunity.
					</Text>
				</Box>
				<Box my="16px">
					<Text variant="blogAnswer" py="16px">
						For more details, visit www.enmasse.world.
					</Text>
				</Box>
			</Box>
			<Box width="100%" height="2px" bgColor="primary.200" />
			<Text
				variant="blogAnswer"
				lineHeight="30px"
				pt="18px"
				fontStyle="italic"
				p="12px 12px 0px"
				fontWeight="500"
			>
				<Text as="span" fontWeight="700" fontStyle="normal">
					#TheContext by IVCA
				</Text>{" "}
				– features opinion makers from the alternate investing industry with
				strong focus on India as an investment destination. Watch this space for
				new announcements in the sector, viewpoints on investment themes,
				emerging trends, economic reports, analysis and latest industry
				insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with&nbsp;
				{/* The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp; */}
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextHousehold;
